import React from 'react';
import classes from './AnalyticsDashboard.module.scss';
import { FilterItemGroup } from '../../../components/filters/FilterItemGroup';
import { FilterItem } from '../../../components/filters/FilterItem';
import { ButtonGroup } from '../../../components/containers/ButtonGroup';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { BreakpointsEnum } from '../../../constants/breakpoints';
import { AnalyticsVisualizationType, DashboardTab } from './AnalyticsDashboard.controller';
import { Overview } from './Overview';
import { NavBar } from './NavBar';
import classNames from 'classnames';
import { Engagement } from './Engagement';
import { CategoryUsage } from './CategoryUsage';
import { BiggerScreenPlaceholder } from '../../../components/containers/BiggerScreenPlaceHolder';

type AnalyticsDashboardProps = {
  view: AnalyticsVisualizationType;
  setView: (view: AnalyticsVisualizationType) => void;
  activeTab: DashboardTab;
  setActiveTab: (tab: DashboardTab) => void;
};

export const AnalyticsDashboardView = ({ view, setView, activeTab, setActiveTab }: AnalyticsDashboardProps) => {
  const breakpoint = useBreakpoints();
  const shouldShowSidebar = breakpoint === BreakpointsEnum.xxlarge;
  const shouldShowBiggerScreenPlaceHolder =
    breakpoint === BreakpointsEnum.small || breakpoint === BreakpointsEnum.medium;
  if (shouldShowBiggerScreenPlaceHolder) {
    return <BiggerScreenPlaceholder />;
  }

  return (
    <div className={classNames('grid-x', classes.DashboardContainer)}>
      {shouldShowSidebar && (
        <div className={classNames('grid-y', classes.SideBar)}>
          <FilterItemGroup isFiltered={false} title={'Basic reports'}>
            <FilterItem
              selected={view === AnalyticsVisualizationType.overview}
              loading={false}
              setSelectedHandler={() => setView(AnalyticsVisualizationType.overview)}>
              <div className={classes.FilterItem}>Overview Dashboard</div>
            </FilterItem>
            <FilterItem
              selected={view === AnalyticsVisualizationType.profile}
              loading={false}
              setSelectedHandler={() => setView(AnalyticsVisualizationType.profile)}>
              <div className={classes.FilterItem}>Analyze per Profile</div>
            </FilterItem>
          </FilterItemGroup>
        </div>
      )}
      <div className={classNames('grid-xy', classes.ContentContainer)}>
        <NavBar shouldShowSidebar={shouldShowSidebar} />
        <div className={classNames('grid-xy', classes.MainContent)}>
          <div className={classes.TabButtons}>
            <ButtonGroup size={'medium'}>
              <Button
                type={'button'}
                size={'medium'}
                color={ButtonColorsEnum.primary}
                action={() => setActiveTab(DashboardTab.overview)}
                variant={activeTab === DashboardTab.overview ? 'solid' : 'hollow'}>
                Overview
              </Button>
              <Button
                type={'button'}
                size={'medium'}
                color={ButtonColorsEnum.primary}
                action={() => setActiveTab(DashboardTab.engagement)}
                variant={activeTab === DashboardTab.engagement ? 'solid' : 'hollow'}>
                Engagement
              </Button>
              <Button
                type={'button'}
                size={'medium'}
                color={ButtonColorsEnum.primary}
                action={() => setActiveTab(DashboardTab.category)}
                variant={activeTab === DashboardTab.category ? 'solid' : 'hollow'}>
                Category Performance
              </Button>
            </ButtonGroup>
          </div>
          <div className={classNames('container', classes.ChartsContainers)}>
            {activeTab === DashboardTab.overview && <Overview />}
            {activeTab === DashboardTab.engagement && <Engagement view={view} />}
            {activeTab === DashboardTab.category && <CategoryUsage />}
          </div>
        </div>
      </div>
    </div>
  );
};
